module.exports = __webpack_public_path__ + "img/photo-0021.c9071429.jpg";